angular.module('unica_invitation.invitation_controllers')

.controller('InvitationTagsController', function(
	$rootScope, $scope, $state, $stateParams, getBaseApiURL, Session,
	InvitationEditService, InvitationDeleteService, EventTagListService, FileUploader
) {

	$scope.event_id           = $stateParams.event_id;
	$scope.invitation_list_id = $stateParams.invitation_list_id;
	$scope.id                 = $stateParams.id;
	$scope.isReadonly         = false;


	var invitationTagsData = {};

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getInvitationById($stateParams.id);

	$scope.uploader = new FileUploader({
		autoUpload: true,
		removeAfterUpload: true,
		url: getBaseApiURL + '/invitation-tag/update-invitation-tag-attachment',
		formData: [
			{ invitation_id: $stateParams.id }
		],
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});

	$scope.uploader.onCompleteItem = function(fileItem, response)
	{
		$scope.eventTagList = response.eventTags;
	};

	$scope.changeInvitationTagAttachment = function( tagId )
	{
		$rootScope.eventData.program_changed = true;
		$scope.uploader.formData.push({ 'tag_id' : tagId, 'invitation_id' : $stateParams.id });
	};

	$scope.$on( 'invitation_loaded', function() {

		EventTagListService
			.listByInvitation( $scope.event_id, $rootScope.invitationData.id )
			.then(function(data) {

				$scope.eventTagList = data;

			});


	});


	function saveInvitationTags() {
		// $scope.showLoader();

		// console.log(registrationData);return;

		InvitationEditService
			.updateInvitationTags( $stateParams.id, $scope.eventTagList )
			.then(function(invitation) {
				$scope.hideLoader();

				if ( invitation ) {
					$scope.showSuccessMsg('Tags aggiornati con successo!', '');
					$state.go('app.invitation.list', { event_id: $stateParams.event_id, invitation_list_id: $stateParams.invitation_list_id });
				}
			});
	}


	$scope.saveInvitationTags = function() {
		saveInvitationTags();
	};


	$scope.deleteInvitationTagAttachment = function( eventTagId ) {

		InvitationDeleteService
			.deleteInvitationTagAttachment( $stateParams.id, eventTagId )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Tag aggiornato con successo!', '');
					$scope.eventTagList = data;
					// location.reload();
				}

			});
	};

});